import type { QuizAnswers } from "../quizHelpers";

export type { QuizAnswers } from "../quizHelpers";

export function saveQuizAnswers(slug: string, answers: QuizAnswers) {
  setItem(key(slug, "answers"), answers);
}

export function getQuizAnswers(slug: string): QuizAnswers | null {
  return getItem<QuizAnswers>(key(slug, "answers"));
}

export function saveCurrentQuestionKey(slug: string, questionKey: string) {
  setItem(key(slug, "currentQuestion"), questionKey);
}

export function getSavedQuestionKey(slug: string): string | null {
  return getItem<string>(key(slug, "currentQuestion"));
}

export function markQuizCompleted(slug: string) {
  setItem(key(slug, "completed"), true);
}

export function isQuizCompleted(slug: string): boolean {
  return getItem<boolean>(key(slug, "completed")) === true;
}

export function markLeadCaptureSubmitted(slug: string) {
  setItem(key(slug, "leadCaptureSubmitted"), true);
}

export function hasSubmittedLeadCapture(slug: string): boolean {
  return getItem<boolean>(key(slug, "leadCaptureSubmitted")) === true;
}

export function markExitModalDismissed(slug: string) {
  setItem(key(slug, "exitModalDismissed"), true);
}

export function isExitModalDismissed(slug: string): boolean {
  return getItem<boolean>(key(slug, "exitModalDismissed")) === true;
}

export function saveQuizHistory(slug: string, history: string[]) {
  setItem(key(slug, "history"), history);
}

export function getQuizHistory(slug: string): string[] {
  return getItem<string[]>(key(slug, "history")) ?? [];
}

export function clearQuizData(slug: string) {
  removeItem(key(slug, "answers"));
  removeItem(key(slug, "currentQuestion"));
  removeItem(key(slug, "completed"));
  removeItem(key(slug, "leadCaptureSubmitted"));
  removeItem(key(slug, "exitModalDismissed"));
  removeItem(key(slug, "history"));
}

const key = (slug: string, suffix: string) => `quiz:${slug}:${suffix}`;

function setItem<T>(k: string, value: T) {
  try {
    localStorage.setItem(k, JSON.stringify(value));
  } catch {
    // localStorage may be unavailable due to SSR
  }
}

function getItem<T>(k: string): T | null {
  try {
    const raw = localStorage.getItem(k);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function removeItem(k: string) {
  try {
    localStorage.removeItem(k);
  } catch {
    //todo: implement some sort of error logging for browser
  }
}
